module.exports = require('./helpers/bundle-url').getBundleURL('fDqF5') + "logo-dark.eefe0b7f.svg";